<!--
 * @Descripttion: 多选切换组件
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="base-status-select">
    <div
      :class="
        showItems.includes(item.value)
          ? 'base-status-select-item-active'
          : 'base-status-select-item'
      "
      v-for="item in statusMap"
      :key="item.value"
      @click="onItemClick(item)"
    >
      <div class="base-status-select-item-label">{{ item.label }}</div>
      <div class="base-status-select-item-value">
        <span class="num">{{ item.num }}</span>
        <span class="unit">条</span>
      </div>
      <BaseSvg
        class="base-status-select-item-icon"
        v-show="showItems.includes(item.value)"
        icon-class="gouxuan"
      ></BaseSvg>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { ref, defineEmits, defineProps, withDefaults } from 'vue';
import { BaseSvg } from '@/components/base/base-svg/index';
const emits = defineEmits(['changeStatus']);
const props = withDefaults(
  defineProps<{
    statusMap: Item[];
    defaultValue: number;
  }>(),
  {
    statusMap: null,
    defaultValue: null
  }
);
type Item = { label: string; value: number; num: number };

const showItems = ref([props.defaultValue]);

const onItemClick = (item: Item) => {
  if (showItems.value.includes(item.value)) {
    showItems.value = showItems.value.filter(v => v !== item.value);
  } else if (item.value === null) {
    showItems.value = [item.value];
  } else if (item.value !== null) {
    showItems.value = showItems.value.filter(v => v !== null);
    showItems.value.push(item.value);
  }
  emits('changeStatus', showItems.value);
};
emits('changeStatus', showItems.value);
</script>
<style lang="scss" scoped>
.base-status-select {
  display: flex;
  align-items: center;
  gap: 16px;

  &-item,
  &-item-active {
    position: relative;
    border-radius: 4px;
    background: #fafafa;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    padding: 15px 0 16px 16px;
    cursor: pointer;
    flex: 1;

    &-label {
      font-weight: 400;
      font-size: 14px;
      color: #121619;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    &-value {
      display: flex;
      align-items: flex-end;

      .num {
        font-weight: 400;
        font-size: 20px;
        color: var(--xrk-color-primary);
        line-height: 28px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-right: 3px;
      }
      .unit {
        font-weight: 400;
        font-size: 12px;
        color: #878d96;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        text-transform: none5;
      }
    }
    &-icon {
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
  &-item-active {
    background: #ffffff;
    border: 1px solid var(--xrk-color-primary);
  }
}
</style>
